import services from './../../services/service'; // Service Class
import Settings from './../../components/tools/settings.vue';
import LogoPad from '../../components/templates/logo-pad.vue'
import AccountDropMenu from '../../components/templates/account-menu.vue'
let service = new services();

export default {
  name: "MainHeader",
  props: {headerdata:Object},
  data() {
      return {
        app_name:service.app_name,
        path: (this.$route.path).replace('/',''),
        user: {},
        user_slug: {},
        market:{},
        products: {},
        product: {},
        items:[],
        checked_out_items: [],
        img_url: service.imageURL,
        loggedIn:false,
        server_query_done:false,
        show_back:true,
        cart: this.$store.state.cart,
        can_show_back_nav: true,
        can_show_side_nav: true,
        mall_set:false,
        notifications:{},
        notifications_alert:0,
      }
  },
  
  components: {
    'c-settings':Settings,
    'logo-pad': LogoPad,
    'component-account-menu': AccountDropMenu,
},
methods: {
    back(){
        window.history.back();
    },
    
    display_menu(){
        let status = document.getElementById("main-nav-bar").style.display;
        if(status == "none"){
            document.getElementById("main-nav-bar").style.display = "block";
        }else{
            document.getElementById("main-nav-bar").style.display = "none";
        }
        
    },

    checkLoggedIn(){
        // if(localStorage.getItem("sp_token") != null){
        //     this.loggedIn = true;
        //     this.user = localStorage.getItem("sp_user");
        // }
        let self = this;
        localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
            if(value != undefined) {
                self.loggedIn = true;
                self.user = value;
            }
        });
    },

    setMarketRemote(){
        service.getBusinessByUserName(this, "").then(response => {
            if(response.body.status == 200) {
                this.market = response.body.data;
            }
        }).catch((err) => {
            //maybe no connection ..load from local
           // this.setSellpointLocal(); //removed...caused slower loading
        })
        
    },


    setMarketLocal(){},

    setPageHeaders(){
        // When the user scrolls the page, execute myFunction
        window.onscroll = function() {
            // Get the header
            var stick_header = document.getElementById("pageStickyHeader");

            // Get the offset position of the navbar
            var sticky = stick_header.offsetTop;

            // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
            if (window.pageYOffset > sticky) {
                stick_header.classList.add("header-sticky");
            } else {
                stick_header.classList.remove("header-sticky");
            }
        };
    },

    setStickyHeader() {
        // Get the header
        var stick_header = document.getElementById("pageStickyHeader");

        // Get the offset position of the navbar
        var sticky = stick_header.offsetTop;

        // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
        if (window.pageYOffset > sticky) {
            stick_header.classList.add("header-sticky");
        } else {
            stick_header.classList.remove("header-sticky");
        }
    },

    checkCanShowBackNav(){
        if((this.path == '') || (this.path == 'timeline') || (this.$route.name == 'Onboarding') || (this.$route.name == 'RefGroup')){
            this.can_show_back_nav = false;
        }
    },

    checkCanShowSideNav(){
        if((this.path == 'register') || (this.path == 'login')){
            this.can_show_side_nav = false;
        }
    },
    
    getNotifications(){
        service.getNotifications(this, this.user.user_id).then(response => {
            if(response.body.status == 200) {
                this.notifications_alert = response.body.data_alert_total;
            }
        }).catch((err) => {})
    },
    
    setAppName() {
        // document.addEventListener("scroll", (event) => {
        //    // let lastKnownScrollPosition = window.scrollY;
        //     if (window.pageYOffset > 90) {
        //     document.getElementById("appName").style.display = "block";
        //     } else {
        //         document.getElementById("appName").style.display = "none";
        //     // stick_header.classList.remove("header-sticky");
        //     }
        // });
    },
  },

  mounted: function(){
    this.setAppName();
  },

  created: function() {
    if(this.path == 'buzz'){this.setPageHeaders();} //for pages with scroll-sticky headers
    if(this.path == 'register'){this.show_back = false;}
    this.checkLoggedIn();
    this.checkCanShowSideNav();
    this.checkCanShowBackNav();
    this.getNotifications();
    //load cart
    let self = this;
    localforage.getItem('xvue', function(err, value) { //quick with the callback version
        if(value != undefined) {
            self.cart =  value.cart;
        }else{}
    });
  }
}


// WEBPACK FOOTER //
// ./src/pages/MainHeader/script.js